import { useMutation } from '@tanstack/react-query'

import { api } from '../../../services/api'

export const useSkipOnboadingStep = () =>
  useMutation({
    mutationFn: api.auth.skipOnboadingStep,
    mutationKey: ['skip-onboading'],
  })
